<template>
  <b-form @submit.prevent="onSubmit" v-if="localConfig && userRms">
    <b-card class="mb-2">
      <b-card-header>
        <h5><i class="bi bi-camera-fill"></i> Fotos</h5>
      </b-card-header>
      <b-card-body>
        <b-form-checkbox
          v-model="localConfig.isMandatoryPhotos"
          switch
          class="mb-2"
        >
          Fotos obrigatórias
        </b-form-checkbox>
        <b-form-checkbox v-model="localConfig.useCamera" switch class="mb-2">
          Permitir uso da câmera
        </b-form-checkbox>
        <b-form-checkbox v-model="localConfig.useGallery" switch class="mb-2">
          Permitir uso da galeria
        </b-form-checkbox>
      </b-card-body>
    </b-card>

    <b-card class="mb-2">
      <b-card-header>
        <h5><i class="bi bi-fuel-pump-fill"></i> Abastecimentos</h5>
      </b-card-header>
      <b-card-body>
        <b-form-checkbox
          v-model="localConfig.hasTravelCode"
          switch
          class="mb-2"
        >
          Exibir código de viagem
        </b-form-checkbox>
        <b-form-checkbox
          v-model="localConfig.internalSupply"
          switch
          class="mb-2"
        >
          Permitir abastecimento interno
        </b-form-checkbox>
        <b-form-checkbox
          v-model="localConfig.externalSupply"
          switch
          class="mb-2"
        >
          Permitir abastecimento externo
        </b-form-checkbox>
        <b-collapse :visible="localConfig.externalSupply" class="mt-2">
          <b-form-checkbox v-model="localConfig.totalFuelValue" switch>
            Informar valor total do abastecimento
          </b-form-checkbox>
        </b-collapse>
        <p v-if="!hasSelectedSupplyType" class="text-danger mt-2">
          Selecione pelo menos um tipo de abastecimento
        </p>
        <b-form-checkbox v-model="localConfig.showSupplier" switch class="mt-2">
          Exibir Frentista
        </b-form-checkbox>
        <b-form-checkbox
          v-model="localConfig.verifyMarkerValue"
          switch
          class="mt-2"
        >
          Impedir abastecimento com marcador menor que o anterior
        </b-form-checkbox>
      </b-card-body>
    </b-card>

    <b-card class="mb-2">
      <b-card-header>
        <h5><i class="bi bi-envelope-fill"></i> Envio de E-mail</h5>
      </b-card-header>
      <b-card-body>
        <b-form-checkbox v-model="localConfig.sendMail" switch class="mb-2">
          Enviar e-mail ao registrar abastecimento
        </b-form-checkbox>

        <b-collapse :visible="localConfig.sendMail" class="mt-3">
          <label class="mt-2">Perfis que receberão e-mail:</label>
          <multiselect
            v-model="selectedProfiles"
            :options="optionsProfiles"
            label="text"
            track-by="value"
            placeholder="Selecione perfis"
            :multiple="true"
            :disabled="!localConfig.sendMail"
            class="mb-3"
            style="width: 100%"
          />
          <label class="mt-2">Usuários que receberão e-mail:</label>
          <multiselect
            v-model="selectedUsers"
            :options="optionsUsers"
            label="text"
            track-by="value"
            placeholder="Selecione usuários"
            :multiple="true"
            :disabled="!localConfig.sendMail"
            class="mb-3"
            style="width: 100%"
          />
        </b-collapse>
        <b-form-checkbox
          v-model="localConfig.sendMailIfAverageIsBelowOrAbove"
          switch
          class="mb-2"
        >
          Enviar e-mail caso média esteja abaixo ou acima da meta registrada
          (10%)
        </b-form-checkbox>
        <b-collapse
          :visible="localConfig.sendMailIfAverageIsBelowOrAbove"
          class="mt-3"
        >
          <label class="mt-2">Perfis que receberão e-mail de média:</label>
          <multiselect
            v-model="selectedProfilesAverage"
            :options="optionsProfiles"
            label="text"
            track-by="value"
            placeholder="Selecione perfis"
            :multiple="true"
            :disabled="!localConfig.sendMailIfAverageIsBelowOrAbove"
            class="mb-3"
            style="width: 100%"
          />
          <label class="mt-2">Usuários que receberão e-mail de média:</label>
          <multiselect
            v-model="selectedUsersAverage"
            :options="optionsUsers"
            label="text"
            track-by="value"
            placeholder="Selecione usuários"
            :multiple="true"
            :disabled="!localConfig.sendMailIfAverageIsBelowOrAbove"
            class="mb-3"
            style="width: 100%"
          />
        </b-collapse>
      </b-card-body>
    </b-card>

    <b-row class="mt-2">
      <b-button type="submit" :disabled="!hasSelectedSupplyType">
        <i class="bi bi-save"></i> Salvar
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="ml-2"
        @click="resetToDefault"
      >
        <i class="bi bi-arrow-counterclockwise"></i> Resetar Configurações
      </b-button>
    </b-row>
  </b-form>
</template>

<script>
import _debounce from "lodash/debounce";
export default {
  name: "FuelSupplyFormConfiguration",
  props: {
    initialConfig: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      localConfig: {
        internalSupply: this.initialConfig?.internalSupply || false,
        externalSupply: this.initialConfig?.externalSupply || false,
        isMandatoryPhotos: this.initialConfig?.isMandatoryPhotos || false,
        useCamera: this.initialConfig?.useCamera || false,
        useGallery: this.initialConfig?.useGallery || false,
        totalFuelValue: this.initialConfig?.totalFuelValue || false,
        hasTravelCode: this.initialConfig?.hasTravelCode || false,
        sendMail: this.initialConfig?.sendMail || false,
        companyId: this.initialConfig?.companyId || null,
        id: this.initialConfig?.id || null,
        fuelSupplyEmailNotification:
          this.initialConfig?.fuelSupplyEmailNotification || [],
        fuelSupplyEmailNotificationAverage:
          this.initialConfig?.fuelSupplyEmailNotificationAverage || [],
        sendMailIfAverageIsBelow:
          this.initialConfig?.sendMailIfAverageIsBelow || false,
        showSupplier: this.initialConfig?.showSupplier || false,
        verifyMarkerValue: this.initialConfig?.verifyMarkerValue || false
      },
      optionsProfiles: [],
      optionsUsers: [],
      selectedProfiles: [],
      selectedUsers: [],
      selectedProfilesAverage: [],
      selectedUsersAverage: [],
      userRms: false
    };
  },
  watch: {
    initialConfig: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.localConfig = {
          ...newVal,
          fuelSupplyEmailNotification: newVal.fuelSupplyEmailNotification || [],
          fuelSupplyEmailNotificationAverage:
            newVal.fuelSupplyEmailNotificationAverage || []
        };
        this.debouncedUpdateSelection();
      }
    },

    optionsUsers: {
      deep: true,
      handler() {
        this.debouncedUpdateSelection();
      }
    },
    optionsProfiles: {
      deep: true,
      handler() {
        this.debouncedUpdateSelection();
      }
    }
  },
  created() {
    this.isRmsUser();
    this.debouncedUpdateSelection = _debounce(this.updateSelection, 200);
    this.loadOptionsUsers();
    this.loadOptionsProfiles();

    this.localConfig = {
      ...this.initialConfig,
      fuelSupplyEmailNotification:
        this.initialConfig.fuelSupplyEmailNotification || [],
      fuelSupplyEmailNotificationAverage:
        this.initialConfig.fuelSupplyEmailNotificationAverage || []
    };

    this.debouncedUpdateSelection();
  },
  computed: {
    hasSelectedSupplyType() {
      return this.localConfig.internalSupply || this.localConfig.externalSupply;
    }
  },
  methods: {
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then(response => {
        this.userRms = response.data;
      });
    },
    loadOptionsUsers() {
      this.$apiScheduler.get("/user/getAllUser").then(resp => {
        this.optionsUsers = resp.data.map(u => ({
          value: String(u.value),
          text: u.text
        }));
      });
    },
    loadOptionsProfiles() {
      this.$apiScheduler.get("/profile/getCompanyProfiles/").then(resp => {
        this.optionsProfiles = resp.data.map(p => ({
          value: String(p.id),
          text: p.displayName
        }));
      });
    },
    updateSelection() {
      const notifications = this.localConfig.fuelSupplyEmailNotification || [];

      const notificationsAverage =
        this.localConfig.fuelSupplyEmailNotificationAverage || [];

      const profileIds = notifications
        .filter(item => item.profileId != null)
        .map(item => String(item.profileId));
      this.selectedProfiles = profileIds.map(id => {
        const found = this.optionsProfiles.find(p => p.value === id);
        return found || { value: id, text: `Perfil ${id}` };
      });

      const profileIdsAverage = notificationsAverage
        .filter(item => item.profileId != null)
        .map(item => String(item.profileId));
      this.selectedProfilesAverage = profileIdsAverage.map(id => {
        const found = this.optionsProfiles.find(p => p.value === id);
        return found || { value: id, text: `Perfil ${id}` };
      });

      const userIds = notifications
        .filter(item => item.userId != null)
        .map(item => String(item.userId));
      this.selectedUsers = userIds.map(id => {
        const found = this.optionsUsers.find(u => u.value === id);
        return found || { value: id, text: `Usuário ${id}` };
      });

      const userIdsAverage = notificationsAverage
        .filter(item => item.userId != null)
        .map(item => String(item.userId));
      this.selectedUsersAverage = userIdsAverage.map(id => {
        const found = this.optionsUsers.find(u => u.value === id);
        return found || { value: id, text: `Usuário ${id}` };
      });
    },
    onSubmit() {
      const notifications = [];
      const notificationsAverage = [];

      this.selectedProfiles.forEach(p => {
        notifications.push({
          id: 0,
          companyId: this.localConfig.companyId,
          profileId: p.value,
          userId: null,
          isAverageNotification: false,
          fuelSupplyFormConfigurationId: this.localConfig.id || 0
        });
      });

      this.selectedUsers.forEach(u => {
        notifications.push({
          id: 0,
          companyId: this.localConfig.companyId,
          profileId: null,
          userId: u.value,
          isAverageNotification: false,
          fuelSupplyFormConfigurationId: this.localConfig.id || 0
        });
      });

      this.selectedProfilesAverage.forEach(p => {
        notificationsAverage.push({
          id: 0,
          companyId: this.localConfig.companyId,
          profileId: p.value,
          userId: null,
          isAverageNotification: true,
          fuelSupplyFormConfigurationId: this.localConfig.id || 0
        });
      });

      this.selectedUsersAverage.forEach(u => {
        notificationsAverage.push({
          id: 0,
          companyId: this.localConfig.companyId,
          profileId: null,
          userId: u.value,
          isAverageNotification: true,
          fuelSupplyFormConfigurationId: this.localConfig.id || 0
        });
      });

      this.localConfig.fuelSupplyEmailNotification = notifications;
      this.localConfig.fuelSupplyEmailNotificationAverage = notificationsAverage;
      console.log(this.localConfig);
      this.$emit("on-save", this.localConfig);
    },
    resetToDefault() {
      this.localConfig = {
        isMandatoryPhotos: false,
        useCamera: true,
        useGallery: false,
        internalSupply: true,
        externalSupply: true,
        totalFuelValue: false,
        hasTravelCode: true,
        sendMail: false,
        sendMailIfAverageIsBelowOrAbove: false,
        fuelSupplyEmailNotification: [],
        fuelSupplyEmailNotificationAverage: [],
        verifyMarkerValue: false,
        companyId: this.localConfig.companyId,
        id: this.localConfig.id,
        showSupplier: false
      };
      this.selectedProfiles = [];
      this.selectedUsers = [];
      this.selectedProfilesAverage = [];
      this.selectedUsersAverage = [];
    }
  }
};
</script>

<style scoped>
/* Seus estilos aqui */
</style>
